export enum ValidTypes {
  option1 = "hospital",
  option2 = "laboratory",
  option3 = "pharmacy",
  option4 = "clinic",
}

export enum SpecialityType {
  option1 = "Obstetricis and Gynaecology",
  option2 = "Cardiology",
  option3 = "Endocrinology",
  option4 = "Gastroenterology",
  option5 = "Hematology",
  option6 = "Infectious Disease",
  option7 = "Nephrology",
  option8 = "Oncology",
  option10 = "Pulmonology",
  option11 = "Rheumatology",
  option12 = "General Surgery",
  option13 = "Cardiothoracic Surgery",
  option14 = "Neurosurgery",
  option15 = "Orthopedic Surgery",
  option16 = "Ophthalmology",
  option17 = "Otolaryngolory (ENT)",
  option18 = "Plastic Surgery",
  option19 = "Vascular Surgery",
  option20 = "Neonatology",
  option21 = "Psychiatry",
  option22 = "Dermatology",
  option23 = "Radiology",
  option24 = "General Anesthesiology",
  option25 = "Neurology",
  option26 = "Pathology",
  option27 = "Family Medicine (GP)",
  option28 = "No Specialty",
}

export const specialitySelectType = [
  
  { value: "Obstetricis and Gynaecology", label: "Obstetricis and Gynaecology" },
  { value: "Cardiology", label: "Cardiology" },
  { value: "Endocrinology", label: "Endocrinology" },
  { value: "Gastroenterology", label: "Gastroenterology" },
  { value: "Hematology", label: "Hematology" },
  { value: "Infectious Disease", label: "Infectious Disease" },
  { value: "Nephrology", label: "Nephrology" },
  { value: "Oncology", label: "Oncology" },
  { value: "Pulmonology", label: "Pulmonology" },
  { value: "Rheumatology", label: "Rheumatology" },
  { value: "General Surgery", label: "General Surgery" },
  { value: "Cardiothoracic Surgery", label: "Cardiothoracic Surgery" },
  { value: "Neurosurgery", label: "Neurosurgery" },
  { value: "Orthopedic Surgery", label: "Orthopedic Surgery" },
  { value: "Ophthalmology", label: "Ophthalmology" },
  { value: "Otolaryngolory (ENT)", label: "Otolaryngolory (ENT)" },
  { value: "Plastic Surgery", label: "Plastic Surgery" },
  { value: "Vascular Surgery", label: "Vascular Surgery" },
  { value: "Neonatology", label: "Neonatology" },
  { value: "Psychiatry", label: "Psychiatry" },
  { value: "Dermatology", label: "Dermatology" },
  { value: "Radiology", label: "Radiology" },
  { value: "General Anesthesiology", label: "General Anesthesiology" },
  { value: "Neurology", label: "Neurology" },
  { value: "Pathology", label: "Pathology" },
  { value: "Family Medicine (GP)", label: "Family Medicine (GP)" },
  
];
